module.exports = __webpack_public_path__ + "img/positive.1af5a80a.svg";